import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export const getScansData = async campaignId => {
  const query = `
      query ($campaignId:ID!) {
        campaign(id:$campaignId) {
           scanUsersData{
                nodes{
                    id
                    flyerCode
                    redirectUrl
                    countryCode
                    city
                    ipAddress
                    mobileOs
                    createdAt
                    }
            }
          }
        }
    `

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/gql.js